module.exports = __webpack_public_path__ + "static/media/ICONS_FOLIOS DOCUMENTOS.f2afabd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_FOLIOS DOCUMENTOS.svg
// module id = 483
// module chunks = 0